// extracted by mini-css-extract-plugin
var _1 = "BankAccountConfirmationStyle-module__bank-account-confirmation--description___fpWhE";
var _2 = "BankAccountConfirmationStyle-module__bank-account-confirmation--description___fpWhE";
var _3 = "BankAccountConfirmationStyle-module__zebra-table-container___Os5kK";
var _4 = "BankAccountConfirmationStyle-module__zebra-table-container___Os5kK";
export { _1 as "bank-account-confirmation--description", _2 as "bankAccountConfirmationDescription", _3 as "zebra-table-container", _4 as "zebraTableContainer" }
